import * as actionTypes from '../actions/actionTypes';

const intiData = {
  data: {},
  statuses: {
    basicDetails: {
      status: "incomplete"
    },
    sweepInstructions: {
      status: "incomplete"
    },
    accountInterestAndlimits: {
      status: "optional"
    },
    sweepGroupsAndlimits: {
      status: "optional"
    },
    orderOfSweepExecution: {
      status: "optional"
    }
  }
};

export default function currentProductGlsCashConReducer(state = intiData, action) {
  switch(action.type){
    case actionTypes.SET_CURRENT_PRODUCT_GLS_CASH_CON: {
      let newState = {...state};
      newState.data = action.productGlsCashConData;
      return newState;
    }
    case actionTypes.SET_CURRENT_PRODUCT_GLS_CASH_CON_STATUSES: {
      let newState = {...state};
      newState.statuses = action.statuses;
      return newState;
    }
    case actionTypes.SET_CORSS_BORDER_STATUS: {
      let newState = {...state};
      newState.crossBorder = action.CrossBorderDtata;
      return newState;
    }
    case actionTypes.SET_NEW_SWEEP_ACTIVE_TAB_INDEX: {
        let newState = {...state};
        newState.sweepActiveTabIndex = action.index;
        return newState;
    }
    case actionTypes.RESET_NEW_SWEEP_ACTIVE_TAB_INDEX : {
        let newState = {...state};
        newState.sweepActiveTabIndex = 0;
        return newState;
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/reducers/currentProductGlsCashConReducer.js